<template>
  <div id="notify" class="vs-con-loading__container">
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
        <li class="inline-flex items-end">
          <router-link to="/after-login">
            <feather-icon
              icon="HomeIcon"
              svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
            />
          </router-link>
          <span class="breadcrumb-separator mx-2 mr-1">
            <feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" />
          </span>
        </li>
        <li class="inline-flex items-end">
          <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">All Notification</span>
        </li>
      </ul>
    </div>
    <h3 class="my-4 py-4">Your {{tab}}<span v-if="tab != 'call history'"> notifications</span></h3>
    <span v-if="tab =='appointment'">
      <div v-for="(noti, index) in notiAppointmentList.items" :key="index">
        <vx-card class="my-3" @click="viewNotify(noti)">
          <div class="flex w-full">
            <div class="flex align-left w-11/12">
              <vs-alert
                :color="getNotiTypeColor(noti.type)"
                class="flex align-center justify-center"
                style="width: 90px; height: 25px !important; font-size: 12px"
              >{{noti.type}}</vs-alert>
            </div>
            <div class="text-xs w-1/12 text-center">{{dateAgo(noti.created_at)}}</div>
          </div>
          <div class="flex justify-between">
            <div class="mt-4 text-sm w-11/12">{{noti.content}}</div>
            <div class="w-1/12 flex justify-center">
              <!-- <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 stroke-current cursor-pointer icon-group"
              /> -->
            </div>
          </div>
        </vx-card>
      </div>
      <div v-if="notiAppointmentList && notiAppointmentList._meta && parseInt(notiAppointmentList._meta.pageCount) > 1" class="mt-base">
        <custom-pagination
          class="custom-pagination"
          :totalPages="parseInt(notiAppointmentList._meta.pageCount)"
          :currentPage="currentPage"
          @pageChanged="changePage"
          :key="page_key"
        ></custom-pagination>
      </div>
    </span>
    <span v-else-if="tab == 'call history'">
      <div
        v-for="(noti, index) in callHistoryList.items"
        :key="index"
        class="mb-4 cursor-pointer"
        :class="{'text-danger': noti.status == 'missed_call'}"
        @click="markAsReadAppointment(noti)"
      >
        <vx-card>
          <div class="w-full flex justify-center justify-between w-full mt-1 align-center">
            <div class="w-2/3 pr-2">
              <p class="mb-1 font-bold break-word" :class="`${noti.status == 'missed_call' ? 'text-danger' : 'text-black'}`">{{ noti.name }}</p>
              <div class="flex align-center">
                <p class="text-sm"><feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 mr-1 font-bold" />{{ StringHelper.phoneNumberFormat("1234565679") }}</p>
                <vs-alert v-if="noti.status" :color="getCallingColorByStatus(noti.status)" class="flex align-center justify-center ml-3"
                  style="width: 100px; height: 30px !important; font-size: 12px"
                >{{ getCallingTextByStatus(noti.status) }}</vs-alert>
              </div>
            </div>
            <div class="w-1/3 text-sm text-right flex flex-col justify-between">
              <p>{{dateAgo((noti.created_at))}}</p>
              <p class="text-sm mt-2">{{ formatDateTime(noti.created_at) }}</p>
            </div>
          </div>
        </vx-card>
      </div>
      <div v-if="callHistoryList && callHistoryList._meta && parseInt(callHistoryList._meta.pageCount) > 1" class="mt-base">
        <custom-pagination
          class="custom-pagination"
          :totalPages="parseInt(callHistoryList._meta.pageCount)"
          :currentPage="currentPage"
          @pageChanged="changecallHistoryPage"
          :key="page_key"
        ></custom-pagination>
      </div>
    </span>
    <span v-else>
      <div v-for="(noti, index) in notiSystem.items" :key="index">
        <vx-card class="my-3">
          <div class="flex align-center w-full">
            <div class="w-11/12">
              <div class="mr-6 text-lg font-bold">{{noti.title}}</div>
              <!-- <vs-alert
                :color="getNotiTypeColor(noti.type)"
                class="flex align-center justify-center"
                style="width: 90px; height: 25px !important; font-size: 12px"
              >{{noti.type}}</vs-alert> -->
            </div>
            <div class="text-xs w-1/12 text-center">{{dateAgo(noti.created_at)}}</div>
          </div>
          <div class="flex justify-between">
            <div class="w-11/12">
              <!-- <div class="mt-4 mr-6">{{noti.title}}</div> -->
              <div class="mt-2 text-sm">{{noti.description}}</div>
            </div>
            <div class="w-1/12 flex justify-center">
              <!-- <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 stroke-current cursor-pointer icon-group"
              /> -->
            </div>
          </div>
        </vx-card>
      </div>
      <div v-if="notiSystem && notiSystem._meta && parseInt(notiSystem._meta.pageCount) > 1" class="mt-base">
        <custom-pagination
          class="custom-pagination"
          :totalPages="parseInt(notiSystem._meta.pageCount)"
          :currentPage="currentPage"
          @pageChanged="changeSystemPage"
          :key="page_key"
        ></custom-pagination>
      </div>
    </span>
  </div>
</template>

<script>
import { changeFormatWithDateTime } from '../helper/datetimeHelper';
import { StringHelper } from '../models/string_helper';
export default {
  name: "",
  data() {
    return {
      StringHelper,
      currentPage: 1,
      itemsPerPage: 10,
      // notiAppointmentList: [],
      // notiSystem: [],
      page_key: 0,
      tab: this.$route.params.tab == 'call-history' ? 'call history' : this.$route.params.tab,
      loaded_data_num: 0,
      isOpenLoading: false,
      key: this.$route.query.key ? parseInt(this.$route.query.key) + 1 : 0,
      callHistoryList: {
        items: [
          { id: 1, name: 'Ly Le', phone: '1234565679', created_at: new Date(), is_read: 1, status: 'booked' },
          { id: 2, name: 'Tammy', phone: '1234565679', created_at: new Date(), is_read: 0, status: null },
          { id: 3, name: 'Harry', phone: '1234565679', created_at: new Date(), is_read: 1, status: null },
          { id: 4, name: 'Unknown', phone: '1234565679', created_at: new Date(), is_read: 1, status: 'missed_call' },
          { id: 5, name: 'Lilly', phone: '1234565679', created_at: new Date(), is_read: 1, status: 'booked' },
          { id: 6, name: 'Nicole', phone: '1234565679', created_at: new Date(), is_read: 1, status: null }
        ]
      }
    };
  },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' staff failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Get data failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);

    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    formatDateTime(date) {
      if(date) {
        return changeFormatWithDateTime(date);
      }
      return 'N/A';
    },
    viewNotify(noti) {
      // if (!this.isOpenLoading) {
      //   this.openLoadingInDiv();
      // }
      this.$router.push(
        {
          name: "appointment",
          query: { key: this.key++ },
          params: { id: noti.appointment_id }
        },
        () => {
          this.closeLoading();
        }
      );
    },
    changePage(currentPage) {
      const obj = {
        page: currentPage,
        "per-page": this.itemsPerPage
      };
      this.openLoadingInDiv();
      this.$store.dispatch("notify/NOTIFY_APPOINTMENT", obj).then(() => {
        this.currentPage = currentPage;
        this.page_key++;
        this.closeLoading();
        // this.notiAppointmentList = this.$store.state.notify.notifyList;
      });
    },
    changeSystemPage(currentPage) {
      const obj = {
        page: currentPage,
        "per-page": this.itemsPerPage
      };
      this.openLoadingInDiv();
      this.$store.dispatch("notify/NOTIFY_SYSTEM", obj).then(() => {
        this.currentPage = currentPage;
        this.page_key++;
        this.closeLoading();
        // this.notiSystem = this.$store.state.notify.notifySystemList;
      });
    },
    getNotiTypeColor(noti_type) {
      if (noti_type == "scheduled") return "success";
      if (noti_type == "confirmed") return "primary";
      if (noti_type == "done") return "warning";
      if (noti_type == "canceled") return "danger";
      return "dark";
    },
    getCallingColorByStatus(status) {
      if(status == 'booked') return "primary";
      if(status == 'missed_call') return "danger";
      return "dark";
    },
    getCallingTextByStatus(status) {
      if(status == 'booked') return "Booked";
      if(status == 'missed_call') return "Missed call";
      return "N/A";
    },
    dateAgo(created_at) {
      let create = new Date(created_at);
      let currentDate = new Date();
      let type = "";
      let Difference_In_Time = currentDate.getTime() - create.getTime();
      let Difference_In_Day = 0;
      let Difference_In_Days = Difference_In_Time / (1000 * 3600);
      if (Difference_In_Days < 24) {
        Difference_In_Day = Difference_In_Days;
        type = "h ago";
      }
      if (Difference_In_Days >= 24) {
        Difference_In_Day = Difference_In_Days / 24;
        type = " days ago";
      }
      if (Difference_In_Days >= 720) {
        Difference_In_Day = Difference_In_Days / 720;
        type = " months ago";
      }
      if (Difference_In_Days >= 720 * 12) {
        Difference_In_Day = Difference_In_Days / (720 * 12);
        type = " years ago";
      }
      return Math.round(Difference_In_Day) + type;
    }
  },
  computed:{
    notiAppointmentList(){
      return this.$store.state.notify.notifyList;
    },
    notiSystem(){
      return this.$store.state.notify.notifySystemList;
    }
  },

  created() {
    const obj = {
      page: 1,
      "per-page": 10
    };
    this.$store.dispatch("notify/NOTIFY_APPOINTMENT", obj).then(() => {
      // this.notiAppointmentList = this.$store.state.notify.notifyList;
      this.loaded_data_num++;
    });
    this.$store.dispatch("notify/NOTIFY_SYSTEM", obj).then(() => {
      // this.notiSystem = this.$store.state.notify.notifySystemList;
      this.loaded_data_num++;
    });
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      // eslint-disable-next-line
      handler(to, from) {
        const obj = {
          page: 1,
          "per-page": 10
        };
        if (to.params.tab == "system") {
          this.$store.dispatch("notify/NOTIFY_SYSTEM", obj).then(() => {
            // this.notiSystem = this.$store.state.notify.notifySystemList;
            this.tab = "system";
          });
        }
        if (to.params.tab == "appointment") {
          this.$store.dispatch("notify/NOTIFY_APPOINTMENT", obj).then(() => {
            // this.notiAppointmentList = this.$store.state.notify.notifyList;
            this.tab = "appointment";
          });
        }
        if(to.params.tab == "call-history") {
          this.tab = "call history";
          // this.loaded_data_num = 2;
        }
      }
    },
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 2) {
          this.closeLoading();
        } else {
          this.openLoadingInDiv();
        }
      }
    }
  }
};
</script>
